const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name || localStorage.getItem('userName'),
  logo: state => state.user.logo,
  userIcon: state => state.user.userIcon
}
export default getters
